import React from "react";
import { Dialog, Modal } from "staysure-component-library";

import { ModalType } from "@/app/common-types/modal.type";

function ModalWrapper(props: Readonly<ModalType>) {
  const {
    children,
    isDismissable = true,
    isOpen,
    setIsOpen,
    className,
  } = props;

  return (
    <Modal
      className={className}
      data-testid="modal"
      isOpen={isOpen}
      isDismissable={isDismissable}
      onOpenChange={(open: boolean) => {
        if (!open) {
          setIsOpen(false);
        }
      }}
      underlayStyles={{
        zIndex: 9999,
        background: "rgba(26, 26, 26, 0.6)",
      }}
      modalStyles={{
        display: "flex",
        background: "white",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: 8,
        maxHeight: "90vh",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Dialog>{children}</Dialog>
    </Modal>
  );
}

export default ModalWrapper;
